<template>
    <div id="main-cart" class="main-cart">
        <div class="container">
            <div class="section">
                <h2 class="title is-3 has-text-grey">Warenkorb</h2>
                <CartItemList
                    class="main main-cart__cart-item-list"
                    :cart-items="allCartItems"
                    :has-minimal-items="true"
                    :show-attachments="true"
                />
                <CartSum :show-tax="taxRate > 0" />
            </div>

            <div class="section"></div>

            <div
                class="section has-text-right main-cart__actions"
                v-if="Object.entries(allCartItems).length > 0"
            >
                <div class="secondary-actions">
                    <CreateNewPrintItemButton
                        v-if="Object.entries(allCartItems).length > 0"
                    >
                        <SvgIcon
                            icon="icon--web-application_add"
                            class="is-primary-dark"
                        ></SvgIcon>
                        {{ $t('checkout.upload.addAnother3DFile') }}
                    </CreateNewPrintItemButton>
                    <CreateNewPrintItemButton
                        v-if="Object.entries(allCartItems).length === 0"
                    >
                        <SvgIcon
                            icon="icon--web-application_add"
                            class="is-primary-dark"
                        ></SvgIcon>
                        {{ $t('checkout.cart.actionLabels.choose3DFile') }}
                    </CreateNewPrintItemButton>
                    <div class="p-2">
                        <RouterLink to="/payment-details" class="link"
                            >{{
                                $t(
                                    'checkout.cart.actionLabels.editPaymentDetails'
                                )
                            }}
                        </RouterLink>
                    </div>
                </div>
                <div class="primary-actions">
                    <RouterLink
                        to="/payment-details"
                        v-if="Object.entries(allCartItems).length > 0"
                        class="button is-primary-dark is-outlined px-6"
                        >{{ $t('checkout.cart.actionLabels.generateQuote') }}
                        {{
                            isUserLoggedIn
                                ? ''
                                : $t('login.messages.membersOnly')
                        }}
                    </RouterLink>
                    <RouterLink
                        to="/payment-details"
                        v-if="Object.entries(allCartItems).length > 0"
                        class="button is-primary-dark px-6"
                    >
                        {{ $t('checkout.cart.actionLabels.completeOrder') }}
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartItemList from './CartItemList';
import { mapGetters } from 'vuex';
import CreateNewPrintItemButton from './CreateNewPrintItemButton';
import SvgIcon from '../svg/SvgIcon';
import CartSum from './ReviewOrder/CartSum';

export default {
    name: 'Cart',
    components: { CartSum, CreateNewPrintItemButton, CartItemList, SvgIcon },
    computed: { ...mapGetters(['allCartItems', 'isUserLoggedIn', 'taxRate']) },
    methods: {
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', { urlSlug: '/' });
        },
    },
    created() {
        this.fetchCMSData();
    },
};
</script>

<style></style>
